import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const links = [{
    label: 'Productos',
    href: '#productos'
  }, {
    label: 'Cómo funciona',
    href: '#proceso'
  }, {
    label: 'Reviews',
    href: '#testimonios'
  }, {
    label: 'Envíos',
    href: '#envios'
  }, {
    label: 'Contacto',
    href: '#contacto'
  }];
  return <nav className="fixed top-0 left-0 right-0 z-[100] bg-dark/85 backdrop-blur-md border-b border-dark-border" data-id="element-40">
      <div className="flex justify-between items-center px-[5%] py-[18px]" data-id="element-41">
        <div className="font-bebas text-[1.6rem] tracking-[3px] text-gradient-pink-purple" data-id="element-42">
          GANSTER STYLE
        </div>

        {/* Desktop Menu */}
        <ul className="hidden md:flex gap-8 list-none" data-id="element-43">
          {links.map(item => <li key={item.label} data-id="element-44">
              <a href={item.href} className="text-text-muted no-underline text-[0.82rem] tracking-[1.5px] uppercase transition-colors duration-300 hover:text-neon-pink" data-id="element-45">
                {item.label}
              </a>
            </li>)}
        </ul>

        {/* Mobile Toggle */}
        <button className="md:hidden text-text-main hover:text-neon-pink transition-colors" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-46">
          {isOpen ? <X size={28} data-id="element-47" /> : <Menu size={28} data-id="element-48" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden border-t border-dark-border bg-dark/95 backdrop-blur-xl absolute top-full left-0 right-0 shadow-2xl" data-id="element-49">
          <ul className="flex flex-col list-none p-4 gap-2" data-id="element-50">
            {links.map(item => <li key={item.label} data-id="element-51">
                <a href={item.href} onClick={() => setIsOpen(false)} className="block text-text-main no-underline text-[0.9rem] tracking-[1.5px] uppercase transition-colors duration-300 hover:text-neon-pink p-3 rounded-md hover:bg-white/5" data-id="element-52">
                  {item.label}
                </a>
              </li>)}
          </ul>
        </div>}
    </nav>;
}